var popup_newsletter = {

	init: function(){

		let nl_closed = popup_newsletter.getCookie("nl_closed");
		if (nl_closed != "") {
		 	console.log("Newsletter popup already closed")
		} else {
			setTimeout(function(){
				$(".popup-newsletter").addClass('visible');
			}, 5000);	
		}
        $(".popup-newsletter .btn-close").on('click',function(){
            $(".popup-newsletter").removeClass('visible');

			const d = new Date();
			d.setTime(d.getTime() + (5*24*60*60*1000));
			let expires = "expires="+ d.toUTCString();
			document.cookie = "nl_closed=true;" + expires + ";path=/";
			
        });
	},
	
	getCookie:function(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
	  let c = ca[i];
	  while (c.charAt(0) == ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) == 0) {
		return c.substring(name.length, c.length);
	  }
	}
	return "";
  }
}


$(window).load(function(){
	if($(".popup-newsletter").length){
		popup_newsletter.init();
	}
})